import PropTypes from 'prop-types'

export default function Boolean({value}) {
  return <div>{value ? 'Yes' : 'No'}</div>
}

Boolean.propTypes = {
  value: PropTypes.bool,
}
